module.exports = __webpack_public_path__ + "img/category-favorite-hover.7255af01.png";